import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';

function stringToColor(string: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name1: string, name2?: string) {
  return {
    sx: {
      bgcolor: stringToColor(`${name1}${name2 ?? ''}`),
      borderColor: `${stringToColor(`${name1}${name2 ?? ''}`)} !important`,
      width: 24, 
      height: 24,
      mx: '2.5px',
      fontFamily: 'Work Sans !important',
      fontStyle: 'normal !important',
      fontWeight: '400 !important',
      fontSize: '10px !important',
      lightHeight: '18px !important',
      color: '#fff !important',
    },
    children: `${name1[0]}${name2?.[0] ?? ''}`,
  };
}

interface LetterProps {
  name1: string;
  name2?: string;
}

export default function LetterAvatar(props: LetterProps) {
  return (
    <Stack direction="row" spacing={2}>
      <Avatar {...stringAvatar(props.name1, props.name2)} />
    </Stack>
  );
}
